<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild" :class="{ 'header-fixed': isFixed }">
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>xxx@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo_black.png">
      </div>
      <!-- 联系方式 -->
      <div class="header-nav-right">
        <div class="header-nav-phone">
          <img src="@/assets/img/telephone.png">
        </div>
        <div class="header-nav-login">
          <button class="login-btn" @click="handleLogin">登录</button>
        </div>
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name)">
          <router-link :to="item.path">
            {{ item.name }}
            <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>


    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <!-- <img class="center-block" src="@/assets/img/logo_black.png" alt="logo"> -->
        博腾软件官方网站
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)" data-toggle="collapse" data-target="#menu">
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      isFixed: false, // 是否吸顶
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "产品介绍",
          path: "/product",
          children: [
            // {
            //   name: "智能小镇管理系统",
            //   path: "/software/smartTown"
            // },
            // {
            //   name: "大数据管理系统",
            //   path: "/software/bigData"
            // }
          ]
        },
        {
          name: "解决方案",
          path: "/service",
          children: []
        },
        {
          name: "渠道合作",
          path: "/cooperation",
          children: []
        },
        {
          name: "新闻资讯",
          path: "/newsinformation",
          children: []
        },
        {
          name: "关于我们",
          path: "/companyintroduction",
          children: []
        },
      ]
    };
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    handleLogin() {
      // 在新标签页打开 beten.cn
      window.open('https://e.beten.cn/', '_blank');
    },
    handleScroll() {
      // 获取滚动距离
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.isFixed = scrollTop > 0;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #fff;
  transition: all ease 0.6s;
  z-index: 1000;
}

/* 吸顶状态 */
#header.header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  /* 毛玻璃效果 */
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  /* 兼容性处理 */
  @supports not (backdrop-filter: blur(10px)) {
    background: rgba(255, 255, 255, 0.95) !important;
  }
}

#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  height: 72px;
  position: relative;
  overflow: hidden;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 212px;
  height: 100%;
  float: left;
  position: relative;
  flex-shrink: 0;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 100%;
  height: 45px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}


/* 导航栏右侧容器 */
#header .header-nav .header-nav-right {
  width: auto;
  height: 100%;
  float: right;
  display: flex;
  align-items: center;
  gap: 20px;
  margin-left: 40px;
}

/* 导航栏电话 */
#header .header-nav .header-nav-phone {
  width: 212px;
  height: 100%;
  position: relative;
}

/* 导航栏电话图片 */
#header .header-nav .header-nav-phone img {
  width: 100%;
  /* height: 45px; */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

/* 登录按钮容器 */
#header .header-nav .header-nav-login {
  height: 100%;
  display: flex;
  align-items: center;
}

/* 登录按钮样式 */
#header .header-nav .header-nav-login .login-btn {
  padding: 8px 20px;
  background-color: rgba(0, 106, 255, 1);
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

/* 登录按钮悬停效果 */
#header .header-nav .header-nav-login .login-btn:hover {
  background-color: rgba(0, 85, 204, 1);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 106, 255, 0.3);
}

/* 登录按钮点击效果 */
#header .header-nav .header-nav-login .login-btn:active {
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(0, 106, 255, 0.3);
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 72px;
  float: right;
  margin: 0;
  margin-left: 20px;
  max-width: calc(100% - 500px);
  list-style: none;
  padding: 0;
  overflow: visible;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper>li {
  float: left;
  position: relative;
  flex-shrink: 0;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper>li>a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 0px 20px;
  position: relative;
  display: block;
  height: 100%;
  white-space: nowrap;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper>li>a>i {
  display: block;
  position: absolute;
  bottom: -4px;
  left: 50%;
  width: 0;
  height: 4px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: rgba(0, 106, 255, 1);
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper>li>a>span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover {
  color: rgba(0, 106, 255, 1);
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper>li.active>a {
  color: rgba(0, 106, 255, 1);
  text-decoration: none;
  border-bottom: 4px solid rgba(0, 106, 255, 1);
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper>li>dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper>li>dl>dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper>li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  background: #ccc;
}

/* 中等分辨率自适应 (1200px - 1400px) */
@media screen and (max-width: 1400px) and (min-width: 998px) {
  #header .header-nav .header-nav-wrapper {
    margin-left: 15px;
    max-width: calc(100% - 450px);
  }

  #header .header-nav .header-nav-wrapper>li>a {
    padding: 0px 15px;
    font-size: 14px;
  }

  #header .header-nav .header-nav-right {
    margin-left: 20px;
    gap: 15px;
  }

  #header .header-nav .header-nav-logo {
    width: 180px;
  }

  #header .header-nav .header-nav-phone {
    width: 180px;
  }
}

/* 小分辨率自适应 (998px - 1200px) */
@media screen and (max-width: 1200px) and (min-width: 998px) {
  #header .header-nav .header-nav-wrapper {
    margin-left: 10px;
    max-width: calc(100% - 400px);
  }

  #header .header-nav .header-nav-wrapper>li>a {
    padding: 0px 10px;
    font-size: 13px;
  }

  #header .header-nav .header-nav-right {
    margin-left: 15px;
    gap: 10px;
  }

  #header .header-nav .header-nav-logo {
    width: 150px;
  }

  #header .header-nav .header-nav-phone {
    width: 150px;
  }

  #header .header-nav .header-nav-login .login-btn {
    padding: 6px 15px;
    font-size: 13px;
  }
}

/* 超小分辨率 (997px以下切换到移动端) */
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 46px;
    position: relative;
    color: rgba(0, 0, 0, 0.9);
    size: 18px;
    text-align: center;
    line-height: 46px;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper>li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;

  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper>li>a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;

  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue